import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApi, useDirectory } from "@/hooks/useApi";
import { PageHeader, FilterBar, DataTable, StatusBadge, ErrorBox } from "@/components/common/ui-bits";
import { FormDialog } from "@/components/common/FormDialog";
import { leadFields } from "@/lib/schemas";
import { fmtDate, optionList, LEAD_STATUSES, todayISO } from "@/lib/format";

export default function Leads() {
  const [q, setQ] = useState("");
  const [f, setF] = useState({});
  const { data, loading, error, reload } = useApi("/leads", { q, ...f });
  const { options: staff, name } = useDirectory();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const today = todayISO();

  return (
    <div>
      <PageHeader title="Prospectos" subtitle="Seguimiento de oportunidades antes de convertirlas en clientes."
        actions={<Button onClick={() => setOpen(true)} data-testid="new-lead-button"><Plus className="mr-2 h-4 w-4" />Nuevo prospecto</Button>} />
      <FilterBar search={q} onSearch={setQ} values={f} onChange={setF} testid="leads-filters" filters={[
        { key: "status", label: "Estado", options: optionList(LEAD_STATUSES) },
        { key: "responsible_id", label: "Responsable", options: staff },
      ]} />
      <ErrorBox text={error} />
      <DataTable testid="leads-table" quickView={(r) => r.name} loading={loading} rows={data} onRowClick={(r) => navigate(`/prospectos/${r.id}`)} empty="No hay prospectos."
        columns={[
          { key: "name", label: "Nombre", render: (r) => <span className="font-medium text-slate-900">{r.name}<span className="block text-xs font-normal text-slate-500">{r.company}</span></span> },
          { key: "contact", label: "Contacto", render: (r) => <span className="text-xs">{r.email || "—"}<br />{r.phone}</span> },
          { key: "service_interest", label: "Interés" },
          { key: "responsible_id", label: "Responsable", render: (r) => name(r.responsible_id) },
          { key: "next_followup", label: "Seguimiento", render: (r) => <span className={r.next_followup && r.next_followup < today && !["Ganado", "Perdido"].includes(r.status) ? "font-semibold text-rose-600" : ""}>{fmtDate(r.next_followup)}</span> },
          { key: "status", label: "Estado", render: (r) => <StatusBadge status={r.status} /> },
        ]} />
      <FormDialog open={open} onOpenChange={setOpen} title="Nuevo prospecto" testid="lead-form" fields={leadFields(staff)}
        initial={{ contact_date: today, status: "Nuevo" }}
        onSubmit={async (v) => { const r = await api.post("/leads", v); toast.success("Prospecto creado"); reload(); navigate(`/prospectos/${r.data.id}`); }} />
    </div>
  );
}
